export default __webpack_public_path__ + "static/media/166340.120a19e6.png";